package one.devsbox.shared.ads

import one.devsbox.commons.EType

enum class UserAction(override val mask: Int) : EType {
    VIEW(2),
    ADD(4),
    CHANGE(8),
    DELETE(16);

    companion object : EType.Finder<UserAction>(entries)
}